App.PeakloadBarchartComponent = Em.Component.extend
  classNames: ['peakload-barchart']

  # firstAppeared: false

  didInsertElement: ->
    @_updateBarchart()
    Em.$(window).on('resize', @resizeHandler.bind(@))

  willDestroyElement: ->
    Em.$(window).off('resize', @resizeHandler.bind(@))

  resizeHandler: ->
    Em.run.debounce(@, @_updateBarchart, 100)

  onDataChanged: (->
    @_updateBarchart()
  ).observes('data')


  ###
  # Фунцкия рисования чарта
  ###
  _updateBarchart: ->
    return if @get('isDestroyed') or @get('isDestroying')
    return unless @$()?
    return unless Em.isArray(@get('data'))

    data = @get('data').map (d) -> d.total = d.cancelled + d.complete; d

    # Размеры
    containerWidth =  @$().outerWidth()
    containerHeight =  @$().outerHeight()
    barchartWidth = 850
    barMargin = 12
    barWidth = (barchartWidth - barMargin) / (data.length - 1) - barMargin

    margin =
      top: 50
      bottom: 60
      right: (containerWidth - barchartWidth) / 2
      left: (containerWidth - barchartWidth) / 2

    barchartHeight = containerHeight - margin.top - margin.bottom


    h = d3.scale.linear().range([0, barchartHeight])
    y = d3.scale.linear().range([barchartHeight, 0])
    h.domain([0, d3.max(data, (d) -> d.total)])
    y.domain([0, d3.max(data, (d) -> d.total)])

    # Корневой элемент
    root = d3.select(@$().get(0))

    ###
    # Surface - поверхность для рисования
    ###
    surface = root.selectAll('.barchart-drawing-surface')
          .data([d3.mean( data.map (d) -> d.total )])

    ###
    # Surface: Enter
    ###
    surfaceEnter = surface.enter().append('div')
      .attr('class', 'barchart-drawing-surface')
      .style('position', 'relative')

    # # Добавить среднее значение
    # meanLineEnter = surfaceEnter.append('div')
    #     .attr('class', 'barchart-mean')
    #     .style('border-top', '1px dashed #E2544B')
    #     .style('position', 'absolute')
    #     .style('left', '0')
    #     .style('z-index', '0')

    # meanLineEnter.append('div')
    #   .attr('class', 'mean-count')
    #   .style('margin-top', '-21px')
    #   .style('margin-bottom', '5px')
    #   .style('margin-left', '20px')
    #   .style('font-size', '16px')
    #   .style('color', '#E2544B')

    # meanLineEnter.append('div')
    #   .text('заказов')
    #   .style('margin-left', '20px')
    #   .style('font-size', '12px')
    #   .style('color', '#E2544B')


    # Добавить группу с барами
    surfaceEnter.append('div')
      .attr('class', 'barchart-group')
      .style('left', margin.left + 'px')
      .style('top', margin.top + 'px')
      .style('position', 'absolute')
      .style('width', barchartWidth + 'px')
      .style('height', barchartHeight + 'px')


    ###
    # Surface: Enter + Update
    ###
    # Обновить бэкграунд
    surface.style('width', containerWidth + 'px')
           .style('height', containerHeight + 'px')

    # Обновить среднее значение
    surface.select('.barchart-mean').transition()
      .style('top', d3.mean(data.map((d) -> Math.round(y(d.total) + margin.top))) + 'px')
      .style('width', containerWidth + 'px')

    # Update barchart group
    surface.select('.barchart-group')
      .style('top', margin.top + 'px')
      .style('left', margin.left + 'px')

    # Update barchart group
    surface.select('.mean-count')
      .text((d3.mean(data.map (d) -> d.total)).toFixed(1))

    ###
    # Bars: ENTER
    ###
    scaleX = d3.scale.ordinal()
      .domain(d3.range(data.length))
      .rangeRoundBands([0, barchartWidth])

    barTotal = surface.select('.barchart-group').selectAll('.bar-total').data(data)
    barTotalEnter = barTotal.enter().append('div')
      .attr('class', 'bar-total')
      .style('background', '#2ECC71')
      .style('position', 'absolute')
      .style('border-radius', '4px')
      .style('bottom', '0px')
      .style('left', (d, i) -> scaleX(i) + 'px')
      .style('width', (scaleX.rangeBand() - barMargin) + 'px')

    barTotalEnter.append('div')
      .attr('class', 'bar-cancelled')
      .style('background', '#ddd')
      .style('width', '100%')
      .style('border-radius', '3px 3px 0px 0px')

    barTotalEnter.append('div')
      .attr('class', 'bar-label')
      .style('bottom', '-30px')
      .style('width', '100%')
      .style('text-align', 'center')
      .style('position', 'absolute')
      .style('font-size', '14px')
      .style('font-weight', '100')
      .text((d) -> d.hour)

    ###
    # Bars: ENTER + UPDATE
    ###
    barTotal.transition()
      .duration(200)
      .style('height', (d) -> Math.round(Math.max(h(d.total), 3)) + 'px')

    barTotal.select('.bar-cancelled').transition()
      .duration(200)
      .style('height', (d) -> Math.round(h(d.cancelled)) + 'px')











